import { AnnualReportStep } from '@modeso/types__aumico-lib-annualreport-be';
import { Action, createAction, props } from '@ngrx/store';

//to set all annual report navigation steps
export const setActiveArNavigations = createAction(
    '[Aumico-AnnualReportNavigation] setActiveArNavigations',
    props<{ payload: AnnualReportStep[] }>(),
);

// Set Default order
export const resetActiveArNavigation = createAction('[Aumico-AnnualReportNavigation] resetActiveArNavigation');

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
